import { WorkCenterWeek } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

export function isWorkCenterIncludedInFilterQuery(
  this: UiQueries,
  workCenterWeek: WorkCenterWeek
): boolean {
  if (!this.hasWorkCenterFilter()) {
    return true;
  }

  // at this point in the code workCenterFilter is guaranteed to not be null
  const notNullWorkCenterFilter = this.uiState.workCenterFilter as string;

  if (
    workCenterWeek.workCenter.workCenter
      .toLowerCase()
      .includes(notNullWorkCenterFilter.toLowerCase())
  ) {
    return true;
  }

  return false;
}
